import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import "./styles.scss";

const Hr = ({ className }) => {
  return <hr className={createClassNameString(["Hr m-0", className])} />;
};

export default Hr;
